var d3 = require('d3');
var R = require('ramda');
var day06 = require('./day06/part3');

var input = require('./day06/input.txt');

var {coords, buffer, bounds, biggest} = day06(input);
var boundsWidth = bounds.maxX - bounds.minX + 1;
var boundsHeight = bounds.maxY - bounds.minY + 1;
coords = R.addIndex(R.forEach)((x, i) => { x.i = i; return x; }, coords);
buffer = R.filter(x => x !== null, buffer);

var winner = R.find(x => x.count === biggest, coords);
var frames = R.pipe(R.groupWith((a, b) => a.dist === b.dist))(buffer);

var colorScale = d3.scaleSequential(d3.interpolateRainbow)
            .domain([1, coords.length]);

var rgbRegex = /rgb\((\d+), (\d+), (\d+)\)/;
var hexRegex = /#(..)(..)(..)/;
var toColor = function(i) {
    var value = colorScale(i);
    var rgb = R.match(rgbRegex, value);
    if (rgb.length) {
        return [
            parseInt(rgb[1]),
            parseInt(rgb[2]),
            parseInt(rgb[3]),
        ]
    } else {
        var hex = R.match(hexRegex, value);
        return [
            parseInt(hex[1], 16),
            parseInt(hex[2], 16),
            parseInt(hex[3], 16)
        ]
    }    
}
R.forEach(x => {
    x.getColor = loc => toColor(x.i);
    if (x === winner) {
        x.getColor = loc => (loc.x + loc.y) % 2 === 0 ? toColor(x.i) : R.map(x => x * .4, toColor(x.i));
    }
}, coords);

var canvas = document.getElementById('c');
var width = canvas.clientWidth;
var height = canvas.clientHeight;
canvas.width = boundsWidth;
canvas.height = boundsHeight;

var ctx = canvas.getContext('2d');
ctx.webkitImageSmoothingEnabled = false;
ctx.mozImageSmoothingEnabled = false;
ctx.imageSmoothingEnabled = false;

ctx.scale(width / boundsWidth, height / boundsHeight);

var paused = false;
var i = 0;
var fps, fpsInterval, startTime, now, then, elapsed;

function startAnimating(fps) {
    fpsInterval = 1000 / fps;
    then = window.performance.now();
    startTime = then;
    draw();
}

function draw(t) {
    requestAnimationFrame(draw);
    now = t;
    elapsed = now - then;

    if (elapsed > fpsInterval) {
        if (i < frames.length) {
            for(var loc of frames[i]) {
                var imageData = ctx.createImageData(1, 1);
                var color = loc.dist === 0 ? [0, 0, 0] : loc.coord.getColor(loc);
                imageData.data[0] = color[0];
                imageData.data[1] = color[1];
                imageData.data[2] = color[2];
                imageData.data[3] = 255;
                ctx.putImageData(imageData, loc.x - bounds.minX, loc.y - bounds.minY);
            }
        }
        if (!paused) i++;

        then = now - (elapsed % fpsInterval);
    }
}
startAnimating(20);

// handlers *********************************************************
var pauseButton = document.getElementById('pause');
var stepButton = document.getElementById('step');
var resetButton = document.getElementById('reset');

pauseButton.onclick = function () {
    paused = !paused;
    pauseButton.innerText = paused ? "play" : "pause";
    if (paused) {
        stepButton.removeAttribute('disabled');
    } else {
        stepButton.setAttribute('disabled', 'disabled');
    }
};

stepButton.onclick = function () {
    i++;
};

resetButton.onclick = function () {
    i = 0;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
};


//////////////////
// WEBPACK FOOTER
// ./src/aoc-2018-day-06/index.js
// module id = 292
// module chunks = 0